import { Flex, Grid } from "@chakra-ui/react";
import React from "react";
import RequirementsCard from "../RequirementsCard";
import { getNumAssigned, getNumOwned } from "../../dashboardDataUtils";
import { useAuth } from "../../../../../context";
import { H2Dashboard } from "components/text/headings";

const Tasks = ({ questions }) => {
  const { user } = useAuth();

  return (
    <Flex direction="column" gap={4}>
      <H2Dashboard>Your Tasks</H2Dashboard>
      <Grid templateColumns="repeat(2, 1fr)" gap={4} w="100%" mx="auto" minH="178">
        <RequirementsCard
          email={user?.email}
          numOwned={getNumOwned(questions, user?.email)}
          numAssigned={getNumAssigned(questions, user?.email)}
        />
      </Grid>
    </Flex>
  );
};

export default Tasks;
